import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import { useIsVisible } from '@components';
import { getAllBlogs } from '@store/slices';
import { RootState } from '@share/utils';
import { IBlog } from '@common-types';

import './style.scss';
import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';

export function SearchAshevillePlayNewsEvents(props: { isBlogsPage?: boolean }) {
  
  const { isBlogsPage } = props;

  const [elementRef, isVisible] = useIsVisible<HTMLDivElement>();
  
  const dispatch = useDispatch();

  const blogsStore = useSelector((state: RootState) => state.blogsStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);
  
  const account = loginStore?.account;

  const { blogs } = blogsStore;

  useEffect(() => {
    if (!blogs || blogs.length === 0) {
      dispatch(getAllBlogs());
    }
  }, [blogs]);

  if (!blogs?.length) {
    return null;
  }

  const blogList = isBlogsPage ? blogs : blogs?.slice(0, 4);

  return (
    <div ref={elementRef} className="search-asheville-play-news-events">
      <div className={`search-asheville-play-news-events__container ${isVisible ? 'animated-container' : ''}`}>
        <div className={`main_title_2 ${isVisible ? 'animated-title' : ''}`}>
          <span><em></em></span>
          <h2>News and Events</h2>
          {!isBlogsPage && (
            <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>)}
        </div>

        <div className="search-asheville-play-news-events__content">
          {blogList?.map((blog: IBlog, index: number) => (
            <a 
              key={blog.id}
              href={`/${account?.name}/blog/${blog.id}`}
              className="search-asheville-play-news-events__content-item"
              style={{ animationDelay: `${(index % 2 === 0 ? index : index - 1) / 2 * 0.3}s` }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={blog.mainImage} alt={blog.title} />
              {blog.createdDate && (
                <div className="search-asheville-play-news-events__content-item-date">
                  <span>{moment(blog.createdDate, 'YYYY-MM-DD').format('DD')}</span>
                  <span>{moment(blog.createdDate, 'YYYY-MM-DD').format('MMM')}</span>
                </div>)}

              <div className="search-asheville-play-news-events__content-item-content">
                {blog.createdDate && (
                  <label>{moment(blog.createdDate, 'YYYY-MM-DD').format('MM.DD.YYYY')}</label>
                )}
                <h3>{blog.title}</h3>
                <p>{blog.descriptions.replace(/<[^>]*>/g, '')}</p>
              </div>
            </a>))}
        </div>

        {!isBlogsPage && (
          <a className="search-asheville-play-news-events__footer" href={`/${account?.name}${Routes.Blogs}`} target="_blank" rel="noopener noreferrer">
            <BlueButton>View all news</BlueButton>
          </a>)}
      </div>
    </div>
  );
}

